let hasUserInteracted = false;

const initializeBlock = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  const heroVideoBG = $block.querySelector('video');
  if(!heroVideoBG) return;

  heroVideoBG.setAttribute('playsinline', '');
  heroVideoBG.setAttribute('autoplay', '');
  heroVideoBG.setAttribute('loop', '');
  heroVideoBG.setAttribute('muted', '');
  heroVideoBG.setAttribute('disablepictureinpicture', '');

  if (hasUserInteracted) {
    heroVideoBG.play();
  }
  else {
    let timer = setInterval(() => {
      if (hasUserInteracted) {
        heroVideoBG.play();
        clearInterval(timer);
      }
    }, 1000);
  }
}

export const initializeHeroVideoBGEditor = () => {
  document.addEventListener('click', function() {
    if (!hasUserInteracted) {
      hasUserInteracted = true;
    }
  });

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=hero', initializeBlock );
  }
}